import { render, staticRenderFns } from "./FabricOrderDashboard.vue?vue&type=template&id=ef190ae8"
import script from "./FabricOrderDashboard.vue?vue&type=script&lang=js"
export * from "./FabricOrderDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports